import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Settings, Menu, X } from 'lucide-react';
import { cn } from '@/lib/utils';

export const Navigation = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const navItems = [
    { label: 'HOME', path: '/' },
    { label: 'BOOKINGS', path: '/book' },
  ];

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <header className="relative z-50 border-b border-zinc-800 bg-zinc-950/90 backdrop-blur-lg sticky top-0">
      <div className="container mx-auto px-3 md:px-4">
        <div className="flex items-center justify-between py-3 md:py-4">
          {/* Logo - Compact on mobile */}
          <Link to="/" className="flex items-center gap-2 md:gap-3 flex-shrink-0">
            <div className="w-8 h-8 md:w-10 md:h-10 bg-green-500 flex items-center justify-center">
              <Settings className="w-5 h-5 md:w-6 md:h-6 text-white" />
            </div>
            <div className="hidden sm:block">
              <h1 className="brand-title text-lg md:text-2xl uppercase tracking-wide text-white">
                NAKI TUNE 2.0
              </h1>
              <p className="text-[10px] text-zinc-500 uppercase tracking-[0.15em] hidden md:block">Dyno Tuning</p>
            </div>
            <h1 className="sm:hidden brand-title text-base uppercase tracking-wide text-white">
              NT 2.0
            </h1>
          </Link>

          {/* Center Navigation - Desktop */}
          <nav className="hidden sm:flex items-center gap-1 md:gap-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={cn(
                  "px-3 md:px-6 py-2 font-['Barlow_Condensed'] text-sm md:text-base font-bold uppercase tracking-wider transition-colors rounded",
                  isActive(item.path)
                    ? "bg-green-500 text-black"
                    : "text-zinc-400 hover:text-white hover:bg-zinc-800"
                )}
                data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Mobile Navigation */}
          <nav className="sm:hidden flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={cn(
                  "px-3 py-1.5 font-['Barlow_Condensed'] text-xs font-bold uppercase tracking-wide transition-colors rounded",
                  isActive(item.path)
                    ? "bg-green-500 text-black"
                    : "text-zinc-400 bg-zinc-800"
                )}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Spacer to keep nav centered */}
          <div className="w-8 md:w-10 flex-shrink-0" />
        </div>
      </div>
    </header>
  );
};

export default Navigation;
